<template>
  <div>
    <div v-if="adminStatus.benutzerAnlegen">
      <b-spinner variant="primary" type="grow" class="flaot-center"></b-spinner>
    </div>
    <div v-else>
      <b-form @submit.prevent="benutzerAnlegen" class="text-left">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button v-if="adminRegisterBenutzer" block href="#" v-b-toggle.form-0 variant="primary">{{adminRegisterBenutzer.id}} | {{adminRegisterBenutzer.vorname}} {{adminRegisterBenutzer.name}}</b-button>
            <b-button v-else block href="#" v-b-toggle.form-0 variant="primary">Benutzer</b-button>
          </b-card-header>
          <b-collapse id="form-0" visible accordion="register-accordion" role="tabpanel">
            <b-card-body v-if="adminRegisterBenutzer != null">
              <b-row>
                <b-col>
                  <p><strong>Id:</strong> {{adminRegisterBenutzer.id}}</p>
                  <p><strong>Anmeldename:</strong> {{adminRegisterBenutzer.anmeldename}}</p>
                  <p><strong>Name:</strong> {{adminRegisterBenutzer.vorname}} {{adminRegisterBenutzer.name}}</p>
                  <p><strong>E-Mail:</strong> {{adminRegisterBenutzer.email}}</p>
                  <p><strong>Passwort:</strong> {{adminRegisterBenutzer.passwort}}</p>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-body v-else>
              <b-card-text>
                <b-form-row>
                  <b-col>
                    <b-form-group id="anmeldename-group" label="Anmeldename *" label-for="anmeldename">
                      <b-form-input
                        id="anmeldename"
                        v-model="benutzerDaten.anmeldename"
                        type="text"
                        :state="anmeldenameState"
                        trim
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="vorname-group" label="Vorname *" label-for="vorname">
                      <b-form-input
                        id="vorname"
                        v-model="benutzerDaten.vorname"
                        type="text"
                        :state="vornameState"
                        trim
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="name-group" label="Name *" label-for="name">
                      <b-form-input
                        id="name"
                        type="text"
                        v-model="benutzerDaten.name"
                        :state="nameState"
                        trim
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="email-group" label="E-Mail" label-for="email">
                      <b-form-input
                        id="email"
                        v-model="benutzerDaten.email"
                        type="email"
                        aria-describedby="email-live-feedback"
                        :state="emailState"
                        trim
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="passwort-group" label="Passwort *" label-for="passwort">
                      <b-form-input
                        id="passwort"
                        v-model="benutzerDaten.passwort"
                        type="text"
                        aria-describedby="passwort-live-feedback"
                        trim
                      ></b-form-input>

                      <!-- <b-form-invalid-feedback
                        id="passwort-live-feedback"
                      >Geben Sie eine gültiges Passwort ein. Das Passwort muss mindestens 3 Zeichen lang sein.</b-form-invalid-feedback> -->
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-row>
                  <b-col>
                    <b-button
                      type="submit"
                      variant="success"
                      class="float-right"
                      v-bind:disabled="!benutzerValidation"
                    >Benutzer anlegen</b-button>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle.form-1 variant="primary" v-bind:disabled="adminRegisterBenutzer == null">Benutzer Gerät</b-button>
          </b-card-header>
          <b-collapse id="form-1" accordion="register-accordion" role="tabpanel">
            <b-card-body v-if="adminRegisterBenutzerGeraet != null">
              <b-row>
                <b-col>
                  <p><strong>Id:</strong> {{adminRegisterBenutzerGeraet.id}}</p>
                  <p><strong>Name:</strong> {{adminRegisterBenutzerGeraet.geraetekennung}}</p>
                  <p><strong>SigfoxDevice Id:</strong> {{adminRegisterBenutzerGeraet.sigfoxDeviceId}}</p>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-body v-else>
              <b-card-text>
                <b-form @submit.prevent="adminBenutzerNeuesGeraet">
                  <b-form-group id="geraetekennung-group" label="Name" label-for="geraetekennung">
                    <b-form-input
                      id="geraetekennung"
                      v-model="neuesGeraet.geraetekennung"
                      type="text"
                      required
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group id="sigfoxDeviceId-group" label="SigfoxDevice Id" label-for="sigfoxDeviceId">
                    <b-form-input
                      id="sigfoxDeviceId"
                      v-model="neuesGeraet.sigfoxDeviceId"
                      type="text"
                    ></b-form-input>
                  </b-form-group>
                  <b-row>
                    <b-col>
                      <b-button type="submit" variant="success" class="float-right">Neues Gerät speichern</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle.form-2 variant="primary" v-bind:disabled="adminRegisterBenutzer == null">Benutzer Kontakte</b-button>
          </b-card-header>
          <b-collapse id="form-2" accordion="register-accordion" role="tabpanel">
            <b-card-body v-if="adminRegisterBenutzerKontakte.length > 0">
              <div v-for="kontakt in adminRegisterBenutzerKontakte" :key="kontakt.id">
                <p><strong>Name:</strong> {{kontakt.vorname}} {{kontakt.name}} <strong>Email:</strong> {{kontakt.email}} <strong>Mobilnummer:</strong> {{kontakt.mobil}}</p>
              </div>
            </b-card-body>
            <b-card-body>
              <b-card-text>
                <b-form id="KontaktNeuAnlegen" @submit.prevent="adminBenutzerNeuerKontakt">
                  <b-form-row>
                    <b-col>
                      <b-form-group>
                        <b-form-checkbox
                          id="neuer-kontakt-favorit"
                          v-model="neuerKontakt.favorit"
                          name="favorit"
                          value=1
                          unchecked-value=0
                        >Notfallbenachrichtigungen an diesen Kontakt senden</b-form-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col cols="12" md="6">
                      <b-form-group id="neuer-kontakt-vorname-group" label="Vorname *" label-for="vorname">
                        <b-form-input
                          id="neuer-kontakt-vorname"
                          v-model="neuerKontakt.vorname"
                          type="text"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-group id="neuer-kontakt-name-group" label="Name *" label-for="name">
                        <b-form-input
                          id="neuer-kontakt-name"
                          v-model="neuerKontakt.name"
                          type="text"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>

                  <b-form-row>
                    <b-col cols="12" sm="6">
                      <b-form-group id="neuer-kontakt-email-group" label="E-Mail Adresse für Benachrichtigungen" label-for="email">
                        <b-form-input
                          id="neuer-kontakt-email"
                          v-model="neuerKontakt.email"
                          type="email"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6">
                      <b-form-group id="neuer-kontakt-mobil-group" label="Mobilnummer für Benachrichtigungen" label-for="mobil">
                        <b-form-input id="neuer-kontakt-mobil" v-model="neuerKontakt.mobil" type="text"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                      
                  <b-row>
                    <b-col>
                      <b-button
                        type="submit"
                        variant="success"
                        class="float-right"
                      >Neuen Kontakt speichern</b-button>
                    </b-col>
                  </b-row>
                  
                </b-form>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle.form-1 variant="primary" v-bind:disabled="!benutzerValidation">Persönliches</b-button>
          </b-card-header>
          <b-collapse id="form-1" accordion="register-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <b-form-row>
                  <b-col>
                    <b-form-group id="anrede-group" label="Anrede" label-for="anrede">
                      <b-form-select
                        v-model="benutzerDaten.geschlecht"
                        :state="geschlechtState"
                        id="anrede"
                      >
                        <option value="m">Herr</option>
                        <option value="w">Frau</option>
                        <option value="d">Sonstige</option>
                      </b-form-select>
                    </b-form-group>

                    <b-form-group
                      id="geburtsdatum-group"
                      label="Geburtsdatum"
                      label-for="geburtsdatum"
                    >
                      <b-form-input
                        id="geburtsdatum"
                        type="date"
                        v-model="benutzerDaten.geburtsdatum"
                        :state="geburtstadumState"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>
                <b-row>
                  <b-col>
                    <b-button
                      type="submit"
                      variant="success"
                      class="float-right"
                      v-bind:disabled="!benutzerValidation"
                    >Benutzer anlegen</b-button>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card> -->

        <!-- <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              href="#"
              v-b-toggle.form-2
              variant="primary"
              v-bind:disabled="!benutzerValidation"
            >Anschrift</b-button>
          </b-card-header>
          <b-collapse id="form-2" accordion="register-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <b-form-row>
                  <b-col>
                    <b-form-group
                      id="strasse-group"
                      label="Straße und Hausnummer"
                      label-for="strasse"
                    >
                      <b-form-input
                        id="strasse"
                        v-model="benutzerDaten.strasse"
                        type="text"
                        :state="strasseState"
                        trim
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col cols="4">
                    <b-form-group id="plz-group" label="PLZ" label-for="plz">
                      <b-form-input
                        id="plz"
                        v-model="benutzerDaten.plz"
                        type="text"
                        :state="plzState"
                        trim
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-group id="ort-group" label="Ort" label-for="ort">
                      <b-form-input
                        id="ort"
                        v-model="benutzerDaten.ort"
                        type="text"
                        :state="ortState"
                        trim
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col>
                    <b-form-group id="land-group" label="Land" label-for="land">
                      <b-form-input
                        id="land"
                        v-model="benutzerDaten.land"
                        type="text"
                        :state="landState"
                        trim
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-row>
                  <b-col>
                    <b-button
                      type="submit"
                      variant="success"
                      class="float-right"
                      v-bind:disabled="!benutzerValidation"
                    >Benutzer anlegen</b-button>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card> -->

        <!-- <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              href="#"
              v-b-toggle.form-3
              variant="primary"
              v-bind:disabled="!benutzerValidation"
            >Kontaktinformationen</b-button>
          </b-card-header>
          <b-collapse id="form-3" accordion="register-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <b-form-row>
                  <b-col cols="5">
                    <b-form-group id="tel-group" label="Tel." label-for="tel">
                      <b-form-input
                        id="tel"
                        v-model="benutzerDaten.tel"
                        type="text"
                        :state="telState"
                        trim
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="fax-group" label="Fax" label-for="fax">
                      <b-form-input
                        id="fax"
                        v-model="benutzerDaten.fax"
                        type="text"
                        :state="faxState"
                        trim
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="mobil-group" label="Mobil" label-for="mobil">
                      <b-form-input
                        id="mobil"
                        v-model="benutzerDaten.mobil"
                        type="text"
                        :state="mobilState"
                        trim
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="email-group" label="E-Mail" label-for="email">
                      <b-form-input
                        id="email"
                        v-model="benutzerDaten.email"
                        type="email"
                        aria-describedby="email-live-feedback"
                        :state="emailState"
                        trim
                      ></b-form-input>

                      <b-form-invalid-feedback
                        id="email-live-feedback"
                      >Geben Sie eine gültige E-Mail ein.</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="5" offset="2">
                    <b-form-group id="telG-group" label="Tel. Firma" label-for="telG">
                      <b-form-input
                        id="telG"
                        v-model="benutzerDaten.telG"
                        type="text"
                        :state="telGState"
                        trim
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="faxG-group" label="Fax Firma" label-for="faxG">
                      <b-form-input
                        id="faxG"
                        v-model="benutzerDaten.faxG"
                        type="text"
                        :state="faxGState"
                        trim
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="mobilG-group" label="Mobil Firma" label-for="mobilG">
                      <b-form-input
                        id="mobilG"
                        v-model="benutzerDaten.mobilG"
                        type="text"
                        :state="mobilGState"
                        trim
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="emailG-group" label="E-Mail Firma" label-for="emailG">
                      <b-form-input
                        id="emailG"
                        v-model="benutzerDaten.emailG"
                        type="email"
                        aria-describedby="emailG-live-feedback"
                        :state="emailGState"
                        trim
                      ></b-form-input>

                      <b-form-invalid-feedback
                        id="emailG-live-feedback"
                      >Geben Sie eine gültige E-Mail ein.</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-row>
                  <b-col cols="12">
                    <b-button
                      type="submit"
                      variant="success"
                      class="float-right"
                      v-bind:disabled="!benutzerValidation"
                    >Benutzer anlegen</b-button>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card> -->
      </b-form>
      <p class="text-left small">mit * gekennzeichnete Felder sind Pflichtfelder</p>
      <b-button variant="primary" class="float-right" @click="finish" :disabled="adminRegisterBenutzer == null">Speichern und schließen</b-button>
      <b-button variant="primary" class="float-right mr-2" @click="printBenutzerAsPDF" :disabled="adminRegisterBenutzer == null">Benutzer als PDF drucken</b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { jsPDF } from "jspdf";

export default {
  name: "BenutzerAnlegen",
  computed: {
    ...mapGetters(["adminStatus", "adminRegisterBenutzer", "adminRegisterBenutzerGeraet", "adminRegisterBenutzerKontakte"]),
    geschlechtState() {
      if (this.benutzerDaten.geschlecht === null) {
        return null;
      } else if (
        this.benutzerDaten.geschlecht.toLowerCase() === "m" ||
        this.benutzerDaten.geschlecht.toLowerCase() === "w" ||
        this.benutzerDaten.geschlecht.toLowerCase() === "d"
      ) {
        return true;
      } else {
        return false;
      }
    },
    anmeldenameState() {
      if (this.benutzerDaten.anmeldename === "" || this.benutzerDaten.anmeldename === null) return null;

      return this.benutzerDaten.anmeldename.length > 0 ? true : false;
    },
    vornameState() {
      if (this.benutzerDaten.vorname === "" || this.benutzerDaten.vorname === null) return null;

      return this.benutzerDaten.vorname.length > 0 ? true : false;
    },
    nameState() {
      if (this.benutzerDaten.name === "" || this.benutzerDaten.name === null) return null;

      return this.benutzerDaten.name.length > 0 ? true : false;
    },
    geburtstadumState() {
      if (this.benutzerDaten.geburtsdatum === "" || this.benutzerDaten.geburtsdatum === null) return null;

      return true;
    },
    strasseState() {
      if (this.benutzerDaten.strasse === "" || this.benutzerDaten.strasse === null) return null;

      return this.benutzerDaten.strasse.length > 0 ? true : false;
    },
    plzState() {
      if (this.benutzerDaten.plz === "" || this.benutzerDaten.plz === null) return null;

      return this.benutzerDaten.plz.length > 0 ? true : false;
    },
    ortState() {
      if (this.benutzerDaten.ort === "" || this.benutzerDaten.ort === null) return null;

      return this.benutzerDaten.ort.length > 0 ? true : false;
    },
    landState() {
      if (this.benutzerDaten.land === "" || this.benutzerDaten.land === null) return null;

      return this.benutzerDaten.land.length > 0 ? true : false;
    },
    telState() {
      if (this.benutzerDaten.tel === "" || this.benutzerDaten.tel === null) return null;

      return this.benutzerDaten.tel.length > 0 ? true : false;
    },
    faxState() {
      if (this.benutzerDaten.fax === "" || this.benutzerDaten.fax === null) return null;

      return this.benutzerDaten.fax.length > 0 ? true : false;
    },
    mobilState() {
      if (this.benutzerDaten.mobil === "" || this.benutzerDaten.mobil === null) return null;

      return this.benutzerDaten.mobil.length > 0 ? true : false;
    },
    emailState() {
      if (this.benutzerDaten.email === "" || this.benutzerDaten.email === null) return null;

      return this.emailRegex.test(this.benutzerDaten.email) ? true : false;
    },
    telGState() {
      if (this.benutzerDaten.telG === "" || this.benutzerDaten.telG === null) return null;

      return this.benutzerDaten.telG.length > 0 ? true : false;
    },
    faxGState() {
      if (this.benutzerDaten.faxG === "" || this.benutzerDaten.faxG === null) return null;

      return this.benutzerDaten.faxG.length > 0 ? true : false;
    },
    mobilGState() {
      if (this.benutzerDaten.mobil === "" || this.benutzerDaten.mobil === null) return null;

      return this.benutzerDaten.mobil.length > 0 ? true : false;
    },
    emailGState() {
      if (this.benutzerDaten.emailG === "" || this.benutzerDaten.emailG === null) return null;

      return this.emailRegex.test(this.benutzerDaten.emailG) ? true : false;
    },
    passwortState() {
      if (this.benutzerDaten.passwort === "" || this.benutzerDaten.passwort === null) return null;

      return this.benutzerDaten.passwort.length > 0 ? true : false;
    },
    benutzerValidation() {
      if (
        this.anmeldenameState &&
        this.vornameState &&
        this.nameState &&
        this.passwortState
      ) {
        return true;
      } else {
        return false;
      }
    },
    persoenlichesValidation() {
      if (
        this.geschlechtState &&
        this.vornameState &&
        this.nameState &&
        this.geburtstadumState
      ) {
        return true;
      } else {
        return false;
      }
    },
    anschriftValidation() {
      if (
        this.strasseState &&
        this.plzState &&
        this.ortState &&
        this.landState
      ) {
        return true;
      } else {
        return false;
      }
    },
    kontaktinformationValidation() {
      if (this.telState && this.emailState) {
        return true;
      } else {
        return false;
      }
    },
    passwortValidation() {
      return this.passwortState ? true : false;
    }
  },
  methods: {
    ...mapActions(["adminBenutzerAnlegen", "adminRegisterBenutzerNeuerKontakt", "adminRegisterBenutzerNeuesGeraet", "resetAdminBenutzerData"]),
    benutzerAnlegen() {
      // let user = {
      //   anmeldename: this.benutzerDaten.anmeldename,
      //   email: this.benutzerDaten.email,
      //   name: this.benutzerDaten.name,
      //   passwort: this.benutzerDaten.passwort,
      //   vorname: this.benutzerDaten.vorname
      // }
      
      this.adminBenutzerAnlegen(this.benutzerDaten)
        .then(() => {
          const toastData = {
            title: "",
            msg: "Der Benutzer wurde angelegt.",
            variant: "success"
          };

          if (this.adminStatus.errMsg) {
            (toastData.title = "Es ist etwas schief gelaufen."),
              (toastData.msg = this.adminStatus.errMsg.response.data);
            toastData.variant = "danger";
          }

          this.$emit("updateUserToast", toastData);

          if (!this.adminStatus.errMsg) {
            this.benutzerDaten = {
              anmeldename: null,
              name: null,
              vorname: null,
              geschlecht: null,
              geburtsdatum: null,
              strasse: null,
              plz: null,
              ort: null,
              land: null,
              tel: null,
              fax: null,
              mobil: null,
              email: null,
              telG: null,
              faxG: null,
              mobilG: null,
              emailG: null,
              passwort: null
            }

            // this.$bvModal.hide(`benutzerAnlegen`);
          }
        });
    },
    adminBenutzerNeuesGeraet () {
      this.neuesGeraet.benutzerId = this.adminRegisterBenutzer.id
      this.adminRegisterBenutzerNeuesGeraet({userId: this.adminRegisterBenutzer.id, geraet: this.neuesGeraet}).then(() => {
        const toastData = {
          title: "",
          msg: "Gerät hinzugefügt",
          variant: "success"
        };

        if (this.adminStatus.errMsg) {
          (toastData.title = "Es ist etwas schief gelaufen."),
            (toastData.msg = this.adminStatus.errMsg);
          toastData.variant = "danger";
        }

        this.$emit("updateUserToast", toastData);

        if (!this.adminStatus.errMsg) {
          this.visible = false
          this.neuesGeraet = {
            id: 0,
            geraetekennung: '',
            geraetetypId: 10000001,
            benutzerId: 0,
            sigfoxDeviceId: ''
          }
        }
      });
    },
    adminBenutzerNeuerKontakt () {
      this.adminRegisterBenutzerNeuerKontakt({userId: this.adminRegisterBenutzer.id, kontakt: this.neuerKontakt}).then(() => {
        const toastData = {
          title: "",
          msg: "Der Kontakt wurde gespeichert.",
          variant: "success"
        };

        if (this.adminStatus.errMsg) {
          (toastData.title = "Es ist etwas schief gelaufen."),
            (toastData.msg = this.adminStatus.errMsg);
          toastData.variant = "danger";
        }

        this.$emit("updateUserToast", toastData);

        if (!this.adminStatus.errMsg) {
          this.visible = false
          this.neuerKontakt = {
            vorname: '',
            name: '',
            email: '',
            mobil: '',
            favorit: 0
          }
        }
      });
    },
    printBenutzerAsPDF () {
      const doc = new jsPDF();
      var name = `${this.adminRegisterBenutzer.id}_${this.adminRegisterBenutzer.vorname}_${this.adminRegisterBenutzer.name}.pdf`
      var benutzerDaten = `BENUTZER:\nAnmeldename: ${this.adminRegisterBenutzer.anmeldename}\nName: ${this.adminRegisterBenutzer.vorname} ${this.adminRegisterBenutzer.name}\nE-Mail: ${this.adminRegisterBenutzer.email || ""}\nPasswort: ${this.adminRegisterBenutzer.passwort}\n`

      var benutzerGeraet = ``
      if (this.adminRegisterBenutzerGeraet != null) {
        benutzerGeraet = `ROLLATOR:\nName: ${this.adminRegisterBenutzerGeraet.geraetekennung}\nSigfox Device Id: ${this.adminRegisterBenutzerGeraet.sigfoxDeviceId}\n`
      }

      var benutzerKontakte = ``
      if (this.adminRegisterBenutzerKontakte.length > 0) {
        benutzerKontakte += `KONTAKTE:\n`
        for(var kontakt of this.adminRegisterBenutzerKontakte) {
          benutzerKontakte += `Name: ${kontakt.vorname} ${kontakt.name}\nEmail: ${kontakt.email}\nMobilnummer: ${kontakt.mobil}\n\n`
        }
      }

      doc.text(`https://app.digi-roll.de/start\n\n${benutzerDaten}\n${benutzerGeraet}\n${benutzerKontakte}`, 10, 10)

      
      doc.save(name)
    },
    finish () {
      this.resetAdminBenutzerData()
      this.$bvModal.hide(`benutzerAnlegen`);
    }
  },
  data() {
    return {
      emailRegex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
      benutzerDaten: {
        anmeldename: null,
        name: null,
        vorname: null,
        geschlecht: null,
        geburtsdatum: null,
        strasse: null,
        plz: null,
        ort: null,
        land: null,
        tel: null,
        fax: null,
        mobil: null,
        email: null,
        telG: null,
        faxG: null,
        mobilG: null,
        emailG: null,
        passwort: null
      },
      neuesGeraet: {
        id: 0,
        geraetekennung: '',
        geraetetypId: 10000001,
        benutzerId: 0,
        sigfoxDeviceId: ''
      },
      neuerKontakt: {
        vorname: '',
        name: '',
        email: '',
        mobil: '',
        favorit: 0
      }
    };
  }
};
</script>
